import { formatMoney } from 'helpers/helpers'

// Ступень программы для организаций начисляет либо процент, либо фиксированную сумму
// с каждого чека (award_amount). У гостевых программ — только процент.

export function ruleAwardType(rule) {
	if (rule.award_type) return rule.award_type
	return Number(rule.award_amount) > 0 ? 'amount' : 'percent'
}

export function ruleAwardValue(rule) {
	return ruleAwardType(rule) === 'amount' ? (rule.award_amount ?? '') : (rule.award_percentage ?? '')
}

export function setRuleAwardValue(rule, value) {
	if (ruleAwardType(rule) === 'amount')
		return { ...rule, 'award_type': 'amount', 'award_amount': value, 'award_percentage': '' }
	return { ...rule, 'award_type': 'percent', 'award_percentage': value, 'award_amount': '' }
}

export function setRuleAwardType(rule, type) {
	return setRuleAwardValue({ ...rule, 'award_type': type }, '')
}

// Ступени растут: следующая не меньше предыдущей. Процент и сумму между собой не сравниваем
export function isRuleAwardGrowing(prevRule, nextRule) {
	if (ruleAwardType(prevRule) !== ruleAwardType(nextRule)) return true
	return Number(ruleAwardValue(nextRule)) > Number(ruleAwardValue(prevRule))
}

export function formatRuleAward(rule, t) {
	if (ruleAwardType(rule) === 'amount') return `${formatMoney(rule.award_amount)} ${t('org_award_per_cheque')}`
	return `${rule.award_percentage}%`
}

// Сумма за чек — только у программы для организаций с базой «с продаж»: при базе «по оплатам»
// покупка в долг на продаже баллов не даёт, а оплата долга начисляет только процент
export function isAwardAmountAllowed(data) {
	return data.audience === 'organizations' && data.award_basis !== 'payments'
}

export function hasAmountRules(rules) {
	return (rules ?? []).some(rule => ruleAwardType(rule) === 'amount')
}
